import { API_BASE_URL } from '../../api';
import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { AccountContext } from '../../Contexts/main.context';
import { ClientContext } from '../../Contexts/client.context';
import ClientNavBar from './clientNavBar.component';
import TheClientOutput from './clientOutlet.component';

const ClientLayout = () => {
     const [loading, setLoading] = useState(true);
     const [locations, setLocations] = useState([]);
     const [error, setError] = useState('');
     const navigate = useNavigate();

     const { updateClientlocation, clientLocations } = useContext(ClientContext);
     const { myAccount, updateMyAccount, updateOriginalID, updateActiveOutlet, activeOutlet } = useContext(AccountContext);

     useEffect(() => {

          const fetchLocations = async (clientAccount) => {
               try {
                    const sendData = {
                         clientAccount: clientAccount,
                         script: 'getLocations',
                         token: localStorage.getItem('LGOUser')
                    };

                    const response = await fetch(API_BASE_URL + 'clientSide.php', {
                         method: 'POST',
                         headers: {
                              'Content-Type': 'application/json',
                              Authorization: `Bearer ${localStorage.getItem('LGOUser')}`
                         },
                         body: JSON.stringify(sendData)
                    });

                    const data = await response.json();
                    if (!response.ok || data.status !== 'success') throw new Error(data.message || 'Unable to load locations.');
                    updateOriginalID(clientAccount);
                    setLocations(data.data || []);
                    updateClientlocation(data.data || []);
                    updateActiveOutlet('Locations');
                    setLoading(false);
               } catch (error) {
                    setError(error.message);
                    setLoading(false);
               }
          };


          const checkAndFetch = async () => {
               if (!myAccount || Object.keys(myAccount).length === 0) {
                    const userToken = localStorage.getItem("LGOUser");
                    if (userToken && typeof userToken === 'string') {
                         try {
                              const decoded = jwtDecode(userToken);
                              const currentTime = Math.floor(Date.now() / 1000);

                              if (decoded.exp && decoded.exp > currentTime) {
                                   updateMyAccount(decoded);
                                   updateOriginalID(decoded.clientAccount);
                                   fetchLocations(decoded.clientAccount);
                              } else {
                                   localStorage.removeItem("LGOUser");
                                   navigate("/login");
                              }
                         } catch (error) {

                              localStorage.removeItem("LGOUser");
                              navigate("/login");
                         }
                    } else {
                         navigate("/login");
                    }
               } else {
                    fetchLocations(myAccount.clientAccount);
               }
          };
          checkAndFetch();
     }, []);

     useEffect(() => {
          if (clientLocations && clientLocations.length > 0) {
               const locationCount = clientLocations.filter(location => location.ID === myAccount.clientAccount);
               if (locationCount.length > 0) {
                    setLocations(clientLocations);
               }
          }
     }, [clientLocations]);

     if (loading || !myAccount) {
          return (
               <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                    <div className="spinner-border text-primary" role="status">
                         <span className="visually-hidden">Loading...</span>
                    </div>
               </div>
          );
     }

     if (error) return <div className="alert alert-danger" role="alert">{error}</div>;

     return (
          <div className="client-layout">
               <div className="client-main">
                    <ClientNavBar clients={locations} />
                    <TheClientOutput />
               </div>
          </div>
     );
};

export default ClientLayout;
